import Joi from "joi-browser";

const EmailSchema = Joi.object().keys({
    email: Joi.string()
        .regex(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
        .required()
        .label("Email")
        .error((errors) => {
            function errorsAsString() {
                let err = errors[0];
                switch (err.type) {
                    case "any.empty":
                        return "can't be an empty field.";
                    case "string.regex.base":
                        return "should be somthing like this: example@abc.com";
                }
            }
            return {
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: errorsAsString(),
                },
            };
        }),
});

export default {
    EmailSchema,
};
